import type { IconData } from '@stacksjs/iconify-core'

export const spa: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M382.988 237.57a251.85 251.85 0 0 0-102.8-180.91L251.657 36l-26.735 20.79a250.84 250.84 0 0 0-96.279 180.71A176 176 0 0 0 96 234.451H16V300c0 97.047 78.953 176 176 176h128c97.047 0 176-78.953 176-176v-65.549h-80a176 176 0 0 0-33.012 3.119M244.568 82.05l7.775-6.05l9.08 6.575a219.73 219.73 0 0 1 90.163 164.079A177.03 177.03 0 0 0 256 337.171a177.02 177.02 0 0 0-95.824-90.6A217.52 217.52 0 0 1 244.568 82.05M240 444h-48c-79.4 0-144-64.6-144-144v-33.549h48c79.4 0 144 64.6 144 144Zm224-144c0 79.4-64.6 144-144 144h-48v-33.549c0-79.4 64.6-144 144-144h48Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default spa
